import { TEXTS } from "@cart-ui/constants";
import { format } from "@swiggy-private/core-ui";

export const getHourMinSecFromDuration = (
    duration: number,
): {
    seconds: number;
    minutes: number;
    hours: number;
} => {
    const secondsToDisplay = duration % 60;
    const minutesRemaining = (duration - secondsToDisplay) / 60;
    const minutesToDisplay = minutesRemaining % 60;
    const hoursToDisplay = (minutesRemaining - minutesToDisplay) / 60;

    return {
        seconds: secondsToDisplay,
        minutes: minutesToDisplay,
        hours: hoursToDisplay,
    };
};

const appendZero = (time: string): string => {
    if (time.length == 1) return `0${time}`;
    return time;
};

export const getTimeInFormat = (remainingTime: { seconds: number; minutes: number; hours: number }): string => {
    if (remainingTime.hours !== 0 || remainingTime.minutes !== 0 || remainingTime.seconds !== 0) {
        return format(
            TEXTS.TIMER_TEXT,
            appendZero(`${remainingTime.hours}`),
            appendZero(`${remainingTime.minutes}`),
            appendZero(`${remainingTime.seconds}`),
        );
    }
    return TEXTS.DEFAULT_TIME;
};
